import Select, { StylesConfig } from 'react-select';

type Props = Record<string, any> & {
  defaultValue?: string | Date | number;
  onChange(props: any): any;
  options: any[];
  value: Record<string, any> & { label: string | number; value: number };
};

const customStyles: StylesConfig<Record<string, any>> = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'rgba(255, 255, 255, 0)',
    borderRadius: 'unset',
    borderStyle: 'unset',
    borderWidth: 'unset',
    // removes the blue border 'onfocus'
    boxShadow: 'none',
    '&:hover': {
      cursor: 'pointer',
      borderRadius: '2px',
      backgroundColor: 'rgb(229 231 235)',
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: 'rgb(107 114 128)',
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: 'normal',
    fontFamily: 'Roboto',
    padding: '1px',
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    borderRadius: '0.25rem',
    color: 'rgb(10 17 40)',
    backgroundColor:
      state.isSelected || state.isFocused ? 'rgb(229, 231, 235)' : 'unset',
    '&:hover': {
      cursor: 'pointer',
    },
    '&:focus': {
      cursor: 'pointer',
    },
    '&:active': {
      backgroundColor: 'rgb(229, 231, 235)',
      cursor: 'pointer',
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    width: '100px',
    left: '50%',
    transform: 'translateX(-50%)',
  }),
  menuList: (provided, state) => ({
    ...provided,
    padding: '5px',
    overflowX: 'hidden',
  }),
};

export const DatePickerSelect = ({
  isDisabled,
  isRtl,
  isClearable,
  name,
  options,
  onChange,
  value,
}: Props) => {
  return (
    <Select
      styles={customStyles}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      classNamePrefix='select'
      isSearchable={false}
      isDisabled={isDisabled}
      isClearable={isClearable}
      isRtl={isRtl}
      name={name}
      options={options}
      onChange={onChange}
      value={value}
    />
  );
};
